import { notification } from 'antd'

// Intentionally uses antd's static notification API rather than App.useApp().
// These are plain functions called from non-React contexts (mutation
// callbacks), where the useApp() hook can't run, and the app has no root <App>
// wrapper for it to read from. The cost is that toasts don't inherit the
// ConfigProvider theme — negligible here, since the theme only customizes
// tokens (radius/font/colors) that a success/error toast barely surfaces.
// If a root <App> wrapper is added app-wide, revisit this to use useApp().

const PLACEMENT = 'topRight'

export function notifySuccess(message: string, description?: string): void {
  notification.success({
    message,
    description,
    placement: PLACEMENT,
    duration: 4,
  })
}

export function notifyError(message: string, description?: string): void {
  notification.error({
    message,
    description,
    placement: PLACEMENT,
    duration: 6,
  })
}

export function notifyWarning(message: string, description?: string): void {
  notification.warning({
    message,
    description,
    placement: PLACEMENT,
    duration: 5,
  })
}
